"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Selector = void 0;

var Element_1 = require("../Component/Element");
/**
 * The abstract class to define region selectors.
 */


var Selector = /*#__PURE__*/function (_Element_1$Element) {
  _inherits(Selector, _Element_1$Element);

  /**
   * Creates new selector.
   * @param parent - The parent (host) SVG-element.
   * @param paper - The `Snap.Paper` element to draw on.
   * @param boundRect - The bounding box for selector.
   * @param callbacks - The collection of callbacks.
   */
  function Selector(parent, paper, boundRect, callbacks) {
    var _this;

    _classCallCheck(this, Selector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Selector).call(this, paper, boundRect));
    /**
     * The flag to define if selector is enabled or disabled.
     */

    _this.isEnabled = true;
    _this.parentNode = parent;

    if (callbacks !== undefined) {
      _this.callbacks = callbacks;
    } else {
      _this.callbacks = {
        onLocked: null,
        onSelectionBegin: null,
        onSelectionEnd: null,
        onUnlocked: null
      };
    }

    return _this;
  }
  /**
   * Enables and shows this selector.
   */


  _createClass(Selector, [{
    key: "enable",
    value: function enable() {
      if (!this.isEnabled) {
        this.isEnabled = true;
        this.show();
      }
    }
    /**
     * Disables and hides this selector.
     */

  }, {
    key: "disable",
    value: function disable() {
      if (this.isEnabled) {
        this.isEnabled = false;
        this.hide();
      }
    }
    /**
     * Helper function to subscribe collection of elements to specified listeners.
     * @param listeners - The collection of `IEventDescriptor` objects.
     */

  }, {
    key: "subscribeToEvents",
    value: function subscribeToEvents(listeners) {
      var _this2 = this;

      listeners.forEach(function (e) {
        e.base.addEventListener(e.event, _this2.enablify(e.listener.bind(_this2), e.bypass));
      });
    }
    /**
     * Helper function to wrap listener with the enablement flag.
     * @param f - The function to wrap.
     * @param bypass - The `bypass` flag to define whether event should be captured.
     */

  }, {
    key: "enablify",
    value: function enablify(f) {
      var _this3 = this;

      var bypass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return function (args) {
        if (_this3.isEnabled || bypass) {
          f(args);
        }
      };
    }
    /**
     * Shows all the elements in specified array.
     * @param elements - The array of elements to show.
     */

  }, {
    key: "showAll",
    value: function showAll(elements) {
      window.requestAnimationFrame(function () {
        elements.forEach(function (element) {
          if (element.show !== undefined) {
            element.show();
          } else {
            element.node.setAttribute("visibility", "visible");
          }
        });
      });
    }
    /**
     * Hides all the elements in specified array.
     * @param elements - The array of elements to hide.
     */

  }, {
    key: "hideAll",
    value: function hideAll(elements) {
      window.requestAnimationFrame(function () {
        elements.forEach(function (element) {
          if (element.hide !== undefined) {
            element.hide();
          } else {
            element.node.setAttribute("visibility", "hidden");
          }
        });
      });
    }
    /**
     * Resizes all the elements to the `boundRect` of this element.
     * @param elemenets - The array of elements to resize.
     */

  }, {
    key: "resizeAll",
    value: function resizeAll(elements) {
      var _this4 = this;

      window.requestAnimationFrame(function () {
        elements.forEach(function (element) {
          element.resize(_this4.boundRect.width, _this4.boundRect.height);
        });
      });
    }
    /**
     * Helper function to move the cross element to specified position.
     * @param cross - The cross element to move.
     * @param pointTo - The new position of the cross element.
     * @param square - The flag that movement should be related to reference point of a square
     */

  }, {
    key: "moveCross",
    value: function moveCross(cross, pointTo) {
      var square = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      cross.move(pointTo, this.boundRect, square, ref);
    }
    /**
     * Helper function to move a point element to specified position
     * @param point - The point element to move.
     * @param pointTo - The new position of the point.
     */

  }, {
    key: "movePoint",
    value: function movePoint(point, pointTo) {
      point.attr({
        cx: pointTo.x,
        cy: pointTo.y
      });
    }
    /**
     * Helper function to move a line element to specified begin and end positions
     * @param line - The line element to move.
     * @param pointFrom - The begin point.
     * @param pointTo - The end point.
     */

  }, {
    key: "moveLine",
    value: function moveLine(line, pointFrom, pointTo) {
      line.attr({
        x1: pointFrom.x,
        x2: pointTo.x,
        y1: pointFrom.y,
        y2: pointTo.y
      });
    }
  }]);

  return Selector;
}(Element_1.Element);

exports.Selector = Selector;